import { render } from "./LoopCarVideo.vue?vue&type=template&id=450c5c30&scoped=true&ts=true"
import script from "./LoopCarVideo.vue?vue&type=script&lang=ts"
export * from "./LoopCarVideo.vue?vue&type=script&lang=ts"

import "./LoopCarVideo.vue?vue&type=style&index=0&id=450c5c30&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-450c5c30"]])

export default __exports__